/**
 * Cartes « seules possibles » sur une donne stats (4 sièges).
 * Avec équivalence : une seule classe légale = coup forcé.
 */

import { equivalenceClassKey } from './cardEquivalence';
import type { CardNumber } from '../types/game';
import { getPlayableCards } from './cards';
import { handsAtStartOfTrick } from './dealHandsAtTrick';
import type { DiffereStatsDealDetail } from './differeStatsReplay';

/** Clés `${trickIndex}:${seat}` des poses sans choix réel. */
export function computeForcedPlaySeatKeys(
  detail: DiffereStatsDealDetail,
  groupEquiv: boolean,
  lowRankLimit = 5,
): Set<string> {
  const out = new Set<string>();
  const tricks = [...detail.tricks].sort((a, b) => a.trickIndex - b.trickIndex);
  const equivOpts = {
    role: detail.isAttackDeal ? 'attacker' as const : 'defender',
    enableTypeB: true,
    lowRankLimit,
  };

  for (const tr of tricks) {
    const hands = handsAtStartOfTrick(detail, tr.trickIndex + 1);
    if (!hands) continue;

    for (let pos = 0; pos < tr.cards.length; pos++) {
      const seat = ((tr.players[pos] ?? (tr.leader + pos)) % 4 + 4) % 4;
      const hand = hands[seat];
      if (!hand?.length) continue;

      const prior = tr.cards.slice(0, pos) as CardNumber[];
      const legal = getPlayableCards(hand as CardNumber[], prior);
      if (legal.length === 0) continue;

      let forced = false;
      if (!groupEquiv) {
        forced = legal.length === 1;
      } else {
        const handIdx = hand.map(c => c - 1);
        const classes = new Set(
          legal.map(c => equivalenceClassKey(c - 1, handIdx, equivOpts)),
        );
        forced = classes.size === 1;
      }
      if (forced) out.add(`${tr.trickIndex}:${seat}`);
    }
  }
  return out;
}
